// Complete list of Swiss cantons with proper codes and names
// This is the ORIGINAL 26 cantons for team registration form (user-friendly)
export const CANTONS = [
  { code: 'ZH', name: 'Zurich', emoji: '🏙️' },
  { code: 'BE', name: 'Bern', emoji: '🐻' },
  { code: 'LU', name: 'Lucerne', emoji: '🏔️' },
  { code: 'UR', name: 'Uri', emoji: '⛰️' },
  { code: 'SZ', name: 'Schwyz', emoji: '🏰' },
  { code: 'OW', name: 'Obwalden', emoji: '🌲' },
  { code: 'NW', name: 'Nidwalden', emoji: '🌲' },
  { code: 'GL', name: 'Glarus', emoji: '🏔️' },
  { code: 'ZG', name: 'Zug', emoji: '🏢' },
  { code: 'FR', name: 'Fribourg', emoji: '🌉' },
  { code: 'SO', name: 'Solothurn', emoji: '🏛️' },
  { code: 'BS', name: 'Basel-Stadt', emoji: '🏭' },
  { code: 'BL', name: 'Basel-Landschaft', emoji: '🏭' },
  { code: 'SH', name: 'Schaffhausen', emoji: '🏰' },
  { code: 'AR', name: 'Appenzell Ausserrhoden', emoji: '🏔️' },
  { code: 'AI', name: 'Appenzell Innerrhoden', emoji: '🏔️' },
  { code: 'SG', name: 'St. Gallen', emoji: '🏛️' },
  { code: 'GR', name: 'Graubünden', emoji: '⛰️' }, // Keep original name for registration
  { code: 'AG', name: 'Aargau', emoji: '🏛️' },
  { code: 'TG', name: 'Thurgau', emoji: '🌾' },
  { code: 'TI', name: 'Ticino', emoji: '☀️' },
  { code: 'VD', name: 'Vaud', emoji: '🏔️' },
  { code: 'VS', name: 'Valais', emoji: '⛷️' },
  { code: 'NE', name: 'Neuchâtel', emoji: '🏔️' },
  { code: 'GE', name: 'Geneva', emoji: '🌍' },
  { code: 'JU', name: 'Jura', emoji: '🏔️' }
];

// New consolidated cantons for admin panel and internal use
export const NEW_CANTONS = [
  { code: 'Appenzell', name: 'Appenzell', emoji: '🏔️' },
  { code: 'Basel', name: 'Basel', emoji: '🏭' },
  { code: 'Nidwalden', name: 'Nidwalden', emoji: '🌲' },
  { code: 'Grisons', name: 'Grisons', emoji: '⛰️' }
];

// Helper functions
export const getCantonByCode = (code) => {
  return CANTONS.find(canton => canton.code === code);
};

export const getCantonName = (code) => {
  const canton = getCantonByCode(code);
  return canton ? canton.name : code;
};

export const getCantonEmoji = (code) => {
  const canton = getCantonByCode(code);
  return canton ? canton.emoji : '🏛️';
};

export const getAllCantonCodes = () => {
  return CANTONS.map(canton => canton.code);
};

export const getAllCantonNames = () => {
  return CANTONS.map(canton => canton.name);
};

// For form options
export const getCantonOptions = () => {
  return CANTONS.map(canton => ({
    value: canton.code,
    label: `${canton.name} (${canton.code})`
  }));
};

// Get cantons sorted alphabetically by name
export const getSortedCantons = () => {
  return [...CANTONS].sort((a, b) => a.name.localeCompare(b.name));
};

// Get consolidated cantons for registration form (Basel and Appenzell merged)
// This shows only "Basel" and "Appenzell" instead of the split versions
export const getConsolidatedCantonsForRegistration = () => {
  // Filter out the split Basel and Appenzell cantons
  const filtered = CANTONS.filter(canton => 
    !['BS', 'BL', 'AR', 'AI'].includes(canton.code)
  );
  
  // Add consolidated Basel and Appenzell
  const consolidated = [
    ...filtered,
    { code: 'BS', name: 'Basel', emoji: '🏭' }, // Use BS as code (backend will map it)
    { code: 'AR', name: 'Appenzell', emoji: '🏔️' } // Use AR as code (backend will map it)
  ];
  
  // Sort alphabetically by name
  return consolidated.sort((a, b) => a.name.localeCompare(b.name));
};

/**
 * Filter consolidated registration cantons by admin "regions allowed" (season.regions_allowed).
 * Empty or missing list = all consolidated cantons (unchanged behaviour).
 */
export const getConsolidatedCantonsFilteredByRegions = (allowedCodes) => {
  const all = getConsolidatedCantonsForRegistration();
  if (!Array.isArray(allowedCodes) || allowedCodes.length === 0) {
    return all;
  }
  const upper = new Set(allowedCodes.map((c) => String(c).toUpperCase()));
  return all.filter((c) => {
    const code = String(c.code).toUpperCase();
    if (upper.has(code)) return true;
    if (code === 'BS' && (upper.has('BS') || upper.has('BL'))) return true;
    if (code === 'AR' && (upper.has('AR') || upper.has('AI'))) return true;
    return false;
  });
};

// Get sorted canton options for forms
export const getSortedCantonOptions = () => {
  return getSortedCantons().map(canton => ({
    value: canton.code,
    label: `${canton.name} (${canton.code})`
  }));
};